import OptionGroup from '../OptionGroup'
import StepShell, { Question, Hint } from '../StepShell'
import Field, { fieldInputClass } from '../Field'

const DEPARTMENTS = ['Engineering', 'Data / ML', 'Product', 'IT / Infrastructure', 'Other']
const INDUSTRIES = [
  { label: 'Financial Services', value: 'Financial Services' },
  { label: 'Healthcare', value: 'Healthcare' },
  { label: 'Technology', value: 'Technology' },
  { label: 'Retail & Consumer', value: 'Retail & Consumer' },
  { label: 'Government / Public', value: 'Government / Public Sector' },
  { label: 'Other', value: 'Other' },
]
const ORG_SIZES = ['1-10', '11-50', '51-200', '200+']

export default function StepDetailsEnterprise({ answers, dispatch, active }) {
  const onSelect = (group, value) => dispatch({ type: 'SET_ANSWER', field: group, value })
  return (
    <StepShell active={active} step={3} segment="enterprise">
      <Question>Tell us about your organization.</Question>
      <Hint>Helps us route this to the right team and right-size the deployment.</Hint>
      <Field label="Department">
        <OptionGroup group="department" options={DEPARTMENTS} value={answers.department} onSelect={onSelect} />
      </Field>
      <Field label="Role / title" htmlFor="reserve-role">
        <input
          id="reserve-role"
          name="role"
          className={fieldInputClass}
          type="text"
          placeholder="e.g. VP Engineering"
          value={answers.role || ''}
          onChange={(e) => dispatch({ type: 'SET_ANSWER', field: 'role', value: e.target.value })}
        />
      </Field>
      <Field label="Industry">
        <OptionGroup group="industry" options={INDUSTRIES} value={answers.industry} onSelect={onSelect} />
      </Field>
      <Field label="Team / department size">
        <OptionGroup group="orgTeamSize" options={ORG_SIZES} value={answers.orgTeamSize} onSelect={onSelect} />
      </Field>
    </StepShell>
  )
}
